export const WA_NUMBER = "919711177809";

export const waLink = (msg) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(msg)}`;

export const openWhatsApp = (msg) =>
  window.open(waLink(msg), "_blank", "noopener,noreferrer");

export const DEMO_MSG =
  "Hi, I'd like to book a demo class at Goyal Academy\nName-\nClass-\nContact-\nSchool-";

export const PTM_MSG =
  "I need an appointment to meet Sunny Sir for meeting.";

export const enquiryMessage = ({ name, cls, school, subject, contact }) =>
  `Hi, I submitted an enquiry form. I'm interested in Goyal Academy.\nName: ${name}\nClass: ${cls}\nSchool: ${school}\nSubject: ${subject}\nContact No.: ${contact}`;

export const notesMessage = (group) =>
  `Hi, I'd like access to the Notes / Sheets drive for ${group} at Goyal Academy.`;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -90 });
  else el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const mapsEmbed = (address) =>
  `https://www.google.com/maps?q=${encodeURIComponent(address)}&output=embed`;

export const mapsDirections = (address) =>
  `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`;
